import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { DuplikitSettings } from './duplikit-settings.model';

@Injectable({
  providedIn: 'root'
})
export class DataToolsSettingsService {
  disallowedCharacters: String[] = ['-', 'e', 'E', '.', '+'];

  masterIDScriptRequired: Subject<string> = new Subject<string>();
  finderScriptRequired: Subject<string> = new Subject<string>();
  syncRequired: Subject<string> = new Subject<string>();

  constructor(private http: HttpClient) { }

  saveSettings(settings: DuplikitSettings) {
    return this.http.post<any>(`${environment.duplikitUrl}/settings/saveSettings`, settings);
  }

  preventNonNumericValues($event: KeyboardEvent) {
    return !this.disallowedCharacters.includes($event.key);
  }
}
